import axiosConfig from "../axiosConfig";
import store from "../storeConfig";

import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";
import { loadGenericNotification } from "../actions/UIStateActions";

const baseURL = getEnvVars().apiUrl;

export function loadPartnerCategories() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // "Authorization": store.getState().user.user.signInUserSession.idToken.jwtToken
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
    
    try {
      axi.get("/partners/categories")
        .then((result) => {
          var flatCategories = result.data.partnerCategories;

          if (flatCategories === undefined) {
            flatCategories = [];
          }
          /* flatCategories.forEach(element => {
            if(Array.isArray(element.childCategories)){
              flatCategories.push(...element.childCategories);
            }
          }); */
          flatCategories.unshift({
            imageUrl: '',
            name: 'All',
            id: 0
          });
          store.dispatch({
            type: "LOAD_PARTNER_CATEGORIES",
            partnerCategories: result.data.partnerCategories,
            flatCategories: flatCategories
          });
        });
    } catch (error) {
      // console.log(error);
    }
  });
}

export function loadPartners() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
  
    try {
      axi.get("/partners/list")
        .then((result) => {
          var partners = Array.from(result.data.partners);
          partners.forEach(element => {
            element.amountInvested = 0;
            element.amountDonated = 0;
            element.amountInvestedPending = 0;
            element.amountDonatedPending = 0;
            element.registrationStatus = 1;
          });
          const uPartners = store.getState().user.userData.partners;
          var i = 0;
          while (i < uPartners.length) {
            //console.log(partners);
            let el = uPartners[i];
            //console.log(el);
            if (partners.find(elr => elr.name.toLowerCase() === el.subscriptionName) !== undefined) {
              partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).partnerID = el.prtnrIdntfr;
              if(el.amountInvestedConfirmed !== undefined){
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).amountInvested = parseFloat(el.amountInvestedConfirmed);
              }
              if(el.amountDonatedConfirmed !== undefined){
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).amountDonated = parseFloat(el.amountDonatedConfirmed);
              }
              if(el.amountInvestedPending !== undefined){
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).amountInvestedPending = parseFloat(el.amountInvestedPending);
              }
              if(el.amountDonatedPending !== undefined){
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).amountDonatedPending = parseFloat(el.amountDonatedPending);
              }
              if(el.status === 'active') {
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).registrationStatus = 2;
              }
              if(el.status === 'inactive') {
                partners.find(elr => elr.name.toLowerCase() === el.subscriptionName).registrationStatus = 3;
              }
            }
            i++;
          }
          loadRecentPartners();
          store.dispatch({
            type: "LOAD_PARTNERS",
            partners: partners,
          });
        });
    } catch (error) {
      // console.log(error);
    }
  });
}

export function selectCategory(categoryId) {
  store.dispatch({
    type: "SELECT_PARTNER_CATEGORY",
    category: categoryId
  });
}


export function resetPartnerData() {
  store.dispatch({
    type: "RESET_PARTNER_DATA",
  });
}

export async function loadRecentPartners() {
  Auth.currentSession().then( async (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // "Authorization": store.getState().user.user.signInUserSession.idToken.jwtToken
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
    try {
      const loadedData = await AsyncStorage.getItem('RecentPartners');
      var readData = [];
      if (loadedData != null) {
        // console.log("reading ", loadedData);
        readData = JSON.parse(loadedData);
        store.dispatch({
          type: "UPDATE_RECENT_PARTNERS",
          recentPartners: readData
        })
      } else {
        axi.get("/partners/defaultrecent")
        .then(async (result) => {
          // var dataArr = [1025, 1011, 1073, 1079, 1089, 1227, 1008, 1016, 1283, 1027];
          const dataArr = JSON.parse(result.data.body);
          try {
            // console.log("setting ", dataArr);
            await AsyncStorage.setItem('RecentPartners', JSON.stringify(dataArr));
          } catch (e) {

          }
          readData = dataArr;
        
          store.dispatch({
            type: "UPDATE_RECENT_PARTNERS",
            recentPartners: readData
          })
        });
        }
      // var outputData = readData.map(id => store.getState().partners.partners.find(el => el.id === id));
      
    } catch (e) {

    }
  });
}

export async function updateRecentPartners(partnerID) {
  try {
    const pID = parseInt(partnerID);
    var loadedData = await AsyncStorage.getItem('RecentPartners');
    loadedData = JSON.parse(loadedData);
    var existingPartnerIndex = await loadedData.findIndex((e) => e === pID);
    if (existingPartnerIndex != -1) {
      loadedData.splice(existingPartnerIndex, 1);
      loadedData.unshift(pID);
    } else {
      loadedData.unshift(pID);
      loadedData.pop();
    }
    // console.log("setting ", loadedData);
    await AsyncStorage.setItem('RecentPartners', JSON.stringify(loadedData));
    loadRecentPartners();
  } catch (e) {
    // console.error(e);
  }
}

export function shellSignUp() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });

    const firstName = store.getState().user.userData.subscriberDetails.givenName;
    const lastName = store.getState().user.userData.subscriberDetails.familyName;

    var payload = {
      "firstName": firstName,
      "lastName": lastName
    }

    axi.post('/partners/shell/register', payload).then(function (response) {
      // console.log(response);
      if (response.data === null || response.status !== 200){
        // presumed error
        return;
      } else {
        return true;
      }
    });

  });
}

export function promoDataReset() {
  store.dispatch({
    type: "PROMO_RESET"
  });
}

export function shellGetBarcode() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });

    axi.get('/partners/shell/check').then(function (response) {
      // console.log(response);
      if (response.data === null || response.status !== 200){
        // presumed error
        return;
      } else {
        if (response.data.barcodeNo != null) {
          store.dispatch({
            type: "SHELL_ADD_BARCODE",
            barcodeNo: response.data.barcodeNo
          });
        }
      }
    });
  });
}

export function shellInitialSignup(incoming_data) {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });

    axi.post('/partners/shell/signup', incoming_data).then(function (response) {
      // console.log(response);
      if (response.data === null || response.status !== 200){
        // presumed error
        return;
      } else {
        return true;
      }
    });
  });
}


export function modifyPartner(partnerName, mode, incoming_data) {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
  
    if (mode == 1) {
      // ADD MODE
      var data = incoming_data;
      data['memberId'] = store.getState().user.user.username;
      // temp to test realtime signup
      // data['partner_validation_type'] = "Realtime";
        axi.post('/partners/add', data).then(function (response) {
          // console.log(response);
          if (response.data === null || response.status !== 200){
            // presumed error
            loadGenericNotification("Unfortunately we can’t link you through to this partner, the details supplied don’t appear to be registered.");
            return;
          } else {
            loadGenericNotification("Your account is now linked!")
          }
        });
    } else if (mode == 2) {
      // REMOVE MODE
      var data = {
                        "memberId":store.getState().user.user.username,
                        "partnerName":partnerName,
                        "partner_id":incoming_data,
                        "partnerStatus": "inactive",
                        "payload":
                        {
                             "partner_custom_field_A":"", 
                             "partner_custom_field_B":"", 
                             "partner_custom_field_C":"", 
                              "partner_custom_field_D":"", 
                             "partner_custom_field_E":"", 
                             "partner_custom_field_F":"", 
                             "partner_custom_field_G":"", 
                             "partner_custom_field_H":"", 
                             "partner_custom_field_I":"", 
                             "partner_custom_field_J":""
                        }
        }
        axi.post('/partners/update', data).then(function (response) {
          if (response.data === null || response.status !== 200){
            // presumed error
            loadGenericNotification("Unfortunately we can’t link you through to this partner, the details supplied don’t appear to be registered.");
            return;
          } else {
            loadGenericNotification("Your account is now unlinked.")
          }
        });
    } else if (mode == 3) {
      // RELINK MODE
      var data = incoming_data;
      data['memberId'] = store.getState().user.user.username;
      data['partnerStatus'] = "active";
      // need to remove partnerType,
      delete data['partner_type'];
      // need to remove subPartnerType,
      delete data['sub_partner_type'];
      // need to remove partner_validation_type,
      delete data['partner_validation_type'];
      // issue here - we prob have to call add - and switch there for update/add based on mode
        axi.post('/partners/update', data).then(function (response) {
          if (response.data === null || response.status !== 200){
            // presumed error
            loadGenericNotification("Unfortunately we can’t link you through to this partner, the details supplied don’t appear to be registered.");
            return;
          } else {
            loadGenericNotification("Your account is now linked!")
          }
        });
    }
  });
}

